import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "rk_intro_seen_v1";

export default function IntroSplash() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    try { return sessionStorage.getItem(KEY) !== "1"; } catch { return true; }
  });

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      try { sessionStorage.setItem(KEY, "1"); } catch {}
      setShow(false);
    }, 2800);
    // Prevent scroll while intro is playing
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; clearTimeout(t); };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="intro-splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-0 z-[200] bg-[#0A0B10] flex items-center justify-center"
        >
          {/* Radial glow */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(184,130,62,0.18),transparent_55%)]" />
          <motion.div
            initial={{ scale: 0.86, opacity: 0, filter: "blur(6px)" }}
            animate={{ scale: [0.86, 1.02, 1], opacity: 1, filter: "blur(0px)" }}
            exit={{ scale: 1.08, opacity: 0 }}
            transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="absolute inset-0 rounded-3xl blur-3xl bg-[#B8823E]/25" />
            <div className="relative bg-white rounded-2xl p-5 md:p-6 shadow-2xl ring-1 ring-white/10">
              <img src="/rk-steel-logo.png" alt="R K STEEL" className="h-24 md:h-32 w-auto" />
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
            className="absolute bottom-14 text-[10px] tracking-[0.35em] uppercase text-[#B8823E]"
          >
            Recycling Today · Building Tomorrow
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
